module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/7597269cc47cd288d56fc20bf1075091.png";